Revolution.Module.extend({
    NAME: "mde.tooltip-img", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/tooltip-img.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "equalheight", "runEqualHeight", "getHeightsForOffsets");

        //events


        this.initTooltipImg();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },

    onWindowResize: function (e) {

    },

    initTooltipImg: function () {
        $('.js-tooltip-img').each(function (index, elem) {
            var btn = $(elem).find('.js-tooltip-img-btn');
            tippy(btn[0], {
                // appendTo: 'parent',
                content: btn.data('content'),
                arrow: true,
                placement: 'right',
                theme: 'brgm',
                allowHTML: true,
            });
        });

    }

});
